import { jsx } from 'react/jsx-runtime';
import { styled } from 'styled-components';
import { theme } from '../../constants/theme.mjs';
"use strict";
const SvgImage = styled.div`
  background-color: ${({
  $active
}) => $active ? `${theme.colors.primaryBlue}` : "currentcolor"};
  /* Loads Svg as background */
  mask: ${({
  $imageSrc
}) => `url(${$imageSrc}) 50% 50% no-repeat`};
  mask-size: contain;

  /* Ensures we maintain dimensions, when scaling */
  aspect-ratio: ${p => `${p.$imageWidth} / ${p.$imageHeight}`};
  height: ${p => `${p.$renderedHeight}px`};
  width: auto;
`;
const StyleableSvgImage = ({
  src,
  width,
  height,
  renderedHeight,
  className,
  $active
}) => {
  const imageWidth = width ?? typeof src === "string" ? width : src.width;
  const imageHeight = height ?? typeof src === "string" ? height : src.height;
  return /* @__PURE__ */jsx(SvgImage, {
    className,
    $imageSrc: typeof src === "string" ? src : src.src,
    $imageWidth: imageWidth,
    $imageHeight: imageHeight,
    $renderedHeight: renderedHeight ?? imageHeight,
    $active
  });
};
export { StyleableSvgImage };
//# sourceMappingURL=StyleableSvgImage.mjs.map
